import { NzModalRef } from 'ng-zorro-antd/modal';

let describedModalCount = 0;

/**
 * Names a confirm modal and links its message text, so screen readers
 * (e.g. Narrator) announce both when focus lands on the OK button.
 *
 * Call it straight after NzModalService.confirm(): ng-zorro moves focus in
 * when the open animation ends, so attributes added in afterOpen are too
 * late to be announced.
 */
export function describeConfirmModal(ref: NzModalRef, label: string): void {
  const dialog: HTMLElement = ref.containerInstance.getNativeElement();
  dialog.setAttribute('aria-label', label);

  const content = dialog.querySelector<HTMLElement>('.ant-modal-confirm-content');
  if (content) {
    content.id ||= `prism-modal-content-${++describedModalCount}`;
    dialog.setAttribute('aria-describedby', content.id);
  }
}
